<template>
  <div @click="$event.stopPropagation()">
    <Chips
      v-model="selectedLabels"
      :options="mappedLabels"
      @chipRemoved="removeLabel"
      />
    <b-form-group>
      <b-row>
        <b-col>
          <b-form-input
            class="label-input"
            placeholder="Adicionar identificador"
            v-model="desLabel"
            :aria-invalid="!!this.desLabel.trim()"
          />
          <b-form-invalid-feedback  v-if="errorMessage" class="d-block">
            {{errorMessage}}
          </b-form-invalid-feedback>
        </b-col>
        <b-col cols="auto">
          <b-button class="add-label-btn" variant="grey-shadowed" @click="addLabel(desLabel)">
            Salvar
          </b-button>
        </b-col>
      </b-row>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Chips from '@/components/form/Chips';

const matchObjects = (objA, objB) => JSON.stringify(objA) === JSON.stringify(objB);

export default {
  name: 'LabelSelector',
  components: {
    Chips,
  },
  props: {
    value: {
      type: Array,
    },
  },
  data() {
    return {
      selectedLabels: [],
      desLabel: '',
      errorMessage: '',
    };
  },
  computed: {
    ...mapGetters([
      'affiliateLabels',
    ]),
    mappedLabels() {
      return this.affiliateLabels.map(label => ({
        label: label.desLabel,
        value: label.idtUserSupplierLabel,
      }));
    },
  },
  methods: {
    ...mapActions([
      'createLabel',
      'deleteLabel',
    ]),
    async removeLabel(label) {
      const { value } = label;
      try {
        if (value) { await this.deleteLabel(label); }
      } catch (error) {
        this.errorMessage = 'Não foi possivel remover o identificador, tente novamente mais tarde';
      }
    },
    async addLabel() {
      try {
        const desLabel = this.desLabel.trim();
        if (desLabel) {
          await this.createLabel(this.desLabel);
          this.desLabel = '';
          const wrap = document.querySelector('.chip-group');
          if (wrap) {
            wrap.scrollTo({ top: wrap.scrollHeight, left: 0, behavior: 'smooth' });
          }
        } else {
          this.errorMessage = 'Insira o nome do identificador';
        }
      } catch (error) {
        this.errorMessage = error.message || 'Não foi possível salvar o identificador, tente novamente mais tarde';
      }
    },
  },
  watch: {
    selectedLabels(newValue, oldValue) {
      if (!matchObjects(newValue, oldValue)) {
        const labels = this.affiliateLabels
          .filter(label => newValue.includes(label.idtUserSupplierLabel));
        this.toggleControls();
        this.$emit('input', labels);
      }
    },
    desLabel() {
      this.errorMessage = '';
    },
    value(newValue, oldValue) {
      if (newValue
        && newValue.length
        && !matchObjects(newValue, oldValue)) {
        this.selectedLabels = [this.value[0].idtUserSupplierLabel];
      }
    },
  },
  inject: ['toggleControls'],
};
</script>
